var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcBts(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "heroicons-solid/video-camera"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Union"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 12C7.58172 12 4 15.5817 4 20V44C4 48.4183 7.58172 52 12 52H34C38.4183 52 42 48.4183 42 44V20C42 15.5817 38.4183 12 34 12H12Z",
    fill: "#DC143C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.1716 49.9999L46 42.8283V21.1715L53.1716 13.9999C55.6914 11.48 60 13.2647 60 16.8283V47.1715C60 50.7351 55.6914 52.5198 53.1716 49.9999Z",
    fill: "#DC143C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBts);
export default __webpack_public_path__ + "static/media/ic_bts.fe23443a093ecc41fb97dba9ae017520.svg";
export { ForwardRef as ReactComponent };